import { Component, Event, EventEmitter, h, Host } from '@stencil/core';

import wcShared from '@web-components/shared';

import helpdeskCommon from '../../../../utils/HelpdeskCommon.class';
import { Store } from '../../../../utils/Stores/store';

@Component({
  tag: 'modal-reset-module',
  styleUrl: 'modal-reset-module.scss',
  shadow: true,
})
export class ModuleModalReset {
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;

  private async reset() {
    await helpdeskCommon?.resetConversation();
    this.sectionChangeEvent.emit(['chat']);
  }

  private close() {
    Store?.set('displayModal', false);
  }

  render() {
    if (Store?.get('loaderResetConversation')) {
      return <module-loader-component />;
    } else {
      return (
        <Host>
          <div class="modal-reset">
            <p>
              {wcShared?.translate(
                'Poser une nouvelle question supprimera la conversation en cours.',
              )}
            </p>
            <div class="action">
              <button
                onClick={() => {
                  this.reset();
                }}
              >
                {wcShared?.translate('Continuer')}
              </button>
              <button onClick={() => this.close()}>{wcShared?.translate('Annuler')}</button>
            </div>
          </div>
        </Host>
      );
    }
  }
}
